import ReactSlider from 'react-slider';
import styled from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const SliderStructure = styled.div`
  &&& {
    flex: 1;
    display: grid;
    grid-template-columns: ${pxToRem(24)} 1fr ${pxToRem(48)} ${pxToRem(24)};
    grid-template-rows: ${pxToRem(24)} ${pxToRem(16)} ${pxToRem(24)} ${pxToRem(
        8
      )} ${pxToRem(24)};
    column-gap: ${pxToRem(20)};
    align-items: center;
    justify-content: center;
  }
`;

export const TitleWrapper = styled.div`
  &&& {
    display: flex;
    gap: ${pxToRem(8)};
    grid-column: 1/3;
  }
`;

export const CurrentValueWrapper = styled.div`
  &&& {
    grid-column: 3/-1;
    justify-self: end;
  }
`;

export const StyledButton = styled.button`
  &&& {
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    background-color: ${({ theme }) => theme.colors.brand1};
    border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.brand1};
    border-radius: 50%;
    cursor: pointer;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-row: 3 / 4;
  }
`;
export const StyledSlider = styled(ReactSlider)`
  &&& {
    width: 100%;
    height: ${pxToRem(4)};
    border-radius: ${pxToRem(4)};
    grid-column: 2 / 4;
    grid-row: 3 / 4;
  }
`;

export const AnchoredLeft = styled.div`
  &&& {
    grid-column: 1/3;
    grid-row: 5 / 6;
  }
`;
export const AnchoredRight = styled.div`
  &&& {
    grid-column: 3/-1;
    grid-row: 5 / 6;
    justify-self: end;
  }
`;

export const StyledRangeInput = styled.input`
  &&& {
    display: none;
  }
`;

export const SliderBase = styled.div`
  &&& {
    position: relative;
    height: ${pxToRem(4)};
    border-radius: ${pxToRem(4)};
    background: ${({ theme: { colors } }) => colors.neutral200};
  }
`;
export const SliderCursor = styled.div<{ $left?: number }>`
  &&& {
    position: absolute;
    top: ${pxToRem(2)};
    left: ${({ $left }) =>
      $left ? `calc(${$left}% - ${pxToRem(10)})` : pxToRem(-10)};
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    border: ${pxToRem(5)} solid ${({ theme }) => theme.colors.brand1};
    box-shadow: 0 0 ${pxToRem(12)} 0 #00000014;
    color: ${({ theme }) => theme.colors.white};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.white};

    transform: translateY(-50%);
  }
`;

export const TickCircle = styled.div<{ $left?: number }>`
  &&& {
    width: ${pxToRem(4)};
    height: ${pxToRem(4)};
    border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.brand1};
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: ${({ $left }) => $left}%;
  }
`;

export const SliderProgress = styled.div<{ $progress?: number }>`
  &&& {
    height: ${pxToRem(4)};
    border-radius: ${pxToRem(4)};
    background: ${({ theme }) => theme.colors.brand1};
    width: ${({ $progress }) => $progress}%;
  }
`;

export const SliderContainer = styled.div`
  &&& {
    display: flex;
    align-items: center;
    grid-column: 1 / 3;
    gap: ${pxToRem(16)};
  }
`;

export const StyledThumb = styled.div`
  &&& {
    position: relative;
    z-index: 1;
  }
`;
export const StyledThumbCursor = styled.div`
  &&& {
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    border: ${pxToRem(5)} solid ${({ theme }) => theme.colors.brand1};
    box-shadow: 0 0 ${pxToRem(12)} 0 #00000014;
    color: ${({ theme }) => theme.colors.white};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.white};
    cursor: grab;

    position: absolute;
    top: ${pxToRem(-10)};
    left: ${pxToRem(-10)};
  }
`;

export const StyledTrack = styled.div<{ index: number }>`
  &&& {
    top: 0;
    bottom: 0;
    background: ${({ index, theme }) =>
      index === 1 ? theme.colors.neutral200 : theme.colors.brand1};
    border-radius: ${pxToRem(4)};
  }
`;

export const StyledMark = styled.div`
  &&& {
    width: ${pxToRem(4)};
    height: ${pxToRem(4)};
    border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.brand1};
    border-radius: 50%;
  }
`;
